export interface ProvisionAccountRequestModel {
    companyName: string;
    tenantId: string;
    planId: string;
}
